import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute3 = ({
  width = 491,
  height = 254,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 730,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 491 254"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M6,171.501C37.8208,222.271 72.5092,209.313 96.2055,194.421C119.902,179.528 144.275,174.789 195.73,229.621C247.185,284.454 258.695,229.621 274.944,183.59C291.193,137.558 329.783,110.48 378.53,96.2637C427.277,82.0479 502.428,31.9532 488.888,12.999C482.117,3.52181 435.467,-7.98595 405,12.999"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M6,171.501C37.8208,222.271 72.5092,209.313 96.2055,194.421C119.902,179.528 144.275,174.789 195.73,229.621C247.185,284.454 258.695,229.621 274.944,183.59C291.193,137.558 329.783,110.48 378.53,96.2637C427.277,82.0479 502.428,31.9532 488.888,12.999C482.117,3.52181 435.467,-7.98595 405,12.999"
      />
      <path
        opacity={0}
        ref={forwardRef.arrow}
        d="M3.97479 169.424C3.9536 169.194 4.18931 169.028 4.39906 169.124L10.1672 171.782C10.3769 171.878 10.4034 172.166 10.2148 172.299L5.02932 175.966C4.84075 176.099 4.57857 175.978 4.55738 175.748L3.97479 169.424Z"
        fill={stroke}
      />
    </svg>
  )
}

export default ExpeditionRoute3
